import React, { createContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import RouteContants from "../../constants/routesContent.json";
import CriteriaContent from "../../constants/contentFile.json";
import { getstatus, getERTCategoryList, statusAllDetails } from "../../api/Api";
import { emptySpaceValidation } from "../../utils/service";

export const StatusContext = createContext({});
export const StatusContextProvider = ({ children }) => {
  const criteriaList = CriteriaContent?.filter;
  const [filterCriteria, setFilterCriteria] = useState("Select Filter");
  const [showDropdownList, setShowDropdownList] = useState(false);
  const [categoryRequired, setCategoryRequired] = useState(false);
  const [statusData, setStatusData] = useState([]);
  const [filterValue, setFilterValue] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [statusSpinnerStatus, setStatusSpinnerStatus] = useState(false);
  const [employeeData, setEmployeeData] = useState(
    CriteriaContent.filter[5].placeholder
  );
  const navigate = useNavigate();
  const [employeeCode, setEmployeeCode] = useState("");
  const [employeeCodeRequired, setEmployeeCodeRequired] = useState(false);
  const [statusCode, setStatusCode] = useState(0);

  const getStatusData = async (filter, empdata) => {
    setStatusSpinnerStatus(true);
    try {
      const getData = await getstatus(filter, empdata);

      if (getData.data.status === 200) {
        setStatusSpinnerStatus(false);
        const filteredData = getData?.data?.data;
        setStatusData(filteredData);
        if (filterCriteria?.name === "Zone") {
          navigate(RouteContants.STATUSZONE, { state: filteredData });
        } else if (filterCriteria?.name === "Category") {
          navigate(RouteContants.STATUS_CATEGORY, { state: filteredData });
        } else if (filterCriteria?.name === "ERT") {
          const getCategoryListData = await getERTCategoryList();
          const ertcategoryList = getCategoryListData?.data?.data?.ert;
          navigate(RouteContants.STATUS_ERT, {
            state: {
              status: "status",
              filteredData: filteredData?.result?.status,
              ertList: ertcategoryList,
              excelData: filteredData?.excelFile,
            },
          });
        } else if (filterCriteria?.name === "Employee Code/name" && !empdata) {
          setEmployeeCodeRequired(true);
        } else {
          navigate(RouteContants.STATUS_EMPLOYEE, {
            state: { filteredData, empdata },
          });
        }
      }
    } catch (error) {
      setStatusSpinnerStatus(false);
      setStatusCode(error?.response?.data?.status);
      if (error?.response?.data?.status === 400) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 401) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else {
        setShowAlert(true);
        setAlertMessage("Something went wrong");
      }
    }
  };

  const getAllStatus = async () => {
    setStatusSpinnerStatus(true);
    try {
      const getStatusAllData = await statusAllDetails("", 1);
      if (getStatusAllData.data.status === 200) {
        const filteredData = getStatusAllData?.data?.data;
        navigate(RouteContants.STATUS_ALL, { state: filteredData });
        setStatusSpinnerStatus(false);
      }
    } catch (error) {
      setStatusSpinnerStatus(false);
      setStatusCode(error?.response?.data?.status);
      if (error?.response?.data?.status === 400) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 401) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else {
        setShowAlert(true);
        setAlertMessage("Something went wrong");
      }
    }
  };

  const logout = () => {
    localStorage.removeItem("x-access-token");
    localStorage.removeItem("permissions");
    localStorage.removeItem("remember");
    navigate(RouteContants.LOGIN);
  };

  const submitFilter = () => {
    if (filterCriteria != "Select Filter") {
      setCategoryRequired(false);
      if (filterCriteria?.name === "Employee Code/name") {
        if (employeeData === CriteriaContent.filter[5].placeholder) {
          setEmployeeCodeRequired(true);
          setCategoryRequired(true);
        } else {
          getStatusData(filterCriteria?.id, employeeData);
          setEmployeeCodeRequired(false);
        }
      } else if (filterCriteria?.name === "ERT") {
        getStatusData(filterCriteria?.id, "");
      } else if (filterCriteria?.name === "Category") {
        getStatusData(filterCriteria?.id, "");
      } else if (filterCriteria?.name === "All") {
        getAllStatus();
      } else if (filterCriteria?.name === "Zone") {
        getStatusData(filterCriteria?.id, "");
      }
    } else {
      setCategoryRequired(true);
    }
  };
  const providerValue = {
    filterCriteria,
    setFilterCriteria,
    showDropdownList,
    setShowDropdownList,
    employeeData,
    setEmployeeData,
    submitFilter,
    categoryRequired,
    setEmployeeCode,
    employeeCode,
    criteriaList,
    employeeCodeRequired,
    showAlert,
    setShowAlert,
    logout,
    statusCode,
    alertMessage,
    setAlertMessage,
    statusSpinnerStatus,
  };
  return (
    <StatusContext.Provider value={providerValue}>
      {children}
    </StatusContext.Provider>
  );
};
